import BoasVindasPremissasView from "../../components/gestaoOrcamentaria/BoasVindasPremissasView";

export default function BoasVindasPremissas() {
  return <BoasVindasPremissasView />;
}
